import {HttpRequest,HttpMethod} from "./http";

class ReportProvider extends HttpRequest {


	ReportSaleChannel(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/recbysalechannel`,params );
	}

	ReportProduct(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/recbyproduct`,params );
	}

	ReportUser(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/recbyuser`,params );
	}

	ReportUserTeam(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/recbyteam`,params );
	}

	ReportUserAndProduct(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/recbyuserproduct`,params );
	}

	ReportDashboard(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/dashboard`,params );
	}
	
	ReportSummaryWmsProduct(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/summary_wms_product`,params );
	}

	ReportCommission(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/commission`,params );
	}
}

export default ReportProvider